import React from "react";
import MasterDataListPage from "../MasterDataListPage";

export default function ModelsPage() {
    return (
        <MasterDataListPage
            title="Master Data"
            subtitle="รุ่นสินค้า"
            apiPath="/models"
            initialItems={[]}
            createDefaultName="รายการใหม่"
            fieldKey="name"
        />
    );
}
